import {UPDATE_USER_DETAILS, FETCH_USER_ADDRESSES, UPDATE_USER_ADDRESS, 
        CLEAR_USER_DETAILS, FETCH_MY_POLICIES} from '../actions/types';

export const userDetailsPolicyReducer = (state = {} , action) => {
    switch(action.type) {
        case UPDATE_USER_DETAILS:
            return {...state, ...action.payload} || {};
        case FETCH_USER_ADDRESSES:
            return {...state, userAddresses: action.payload} || {};
        case UPDATE_USER_ADDRESS:
            return {...state, userAddress: action.payload} || {};
        case FETCH_MY_POLICIES:
            return {...state, myPolicies: action.payload} || {};
        case CLEAR_USER_DETAILS:
            return {};

        default:
            return state;
    }
}